/**
 * Страница CRM на телефоне не масштабируется — ни сама, ни пальцами.
 *
 * Владелец 06.10.2026: «при открытии клавиатуры в веб-аппе появляется боковой
 * скролл из изменения масштаба… чтобы масштаб вообще нигде не менялся».
 * Приближённая страница шире экрана — её водят вбок, а экран переписки,
 * привязанный к видимой части над клавиатурой (`visual-viewport.ts`), при
 * приближении отвязывается.
 *
 * Источников приближения три, и закрыт каждый своим способом:
 *  - автозум iOS при фокусе в поле — `maximum-scale=1` в viewport (index.html).
 *    Шрифт 16px в полях (globals.css) закрывал только поля уже 1024px и только
 *    этот один случай;
 *  - двойной тап — `touch-action: manipulation` на `html` (globals.css);
 *  - щипок — на Android его снимает `user-scalable=no`, а Safari на iOS этот
 *    запрет игнорирует с iOS 10. Поэтому его жесты гасим здесь.
 *
 * Только на сенсорных экранах: на Mac те же события `gesture*` приходят от
 * щипка по трекпаду, а привычный десктопный масштаб у сотрудника не забираем.
 */

/** Жесты щипка WebKit — других браузеров они не касаются. */
const PINCH_EVENTS = ['gesturestart', 'gesturechange', 'gestureend'] as const;

/** Возвращает функцию снятия — для тестов. */
export function installNoZoomGuard(
  doc: Document = document,
  nav: Pick<Navigator, 'maxTouchPoints'> = navigator,
): () => void {
  if (!(nav.maxTouchPoints > 0)) return () => undefined;
  const block = (e: Event): void => e.preventDefault();
  // passive: false — иначе preventDefault в слушателе браузер проигнорирует.
  for (const type of PINCH_EVENTS) doc.addEventListener(type, block, { passive: false });
  return () => {
    for (const type of PINCH_EVENTS) doc.removeEventListener(type, block);
  };
}
